import { makeStyles, Paper, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoSharpIcon from "@mui/icons-material/InfoSharp";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  InputAdornment,
  styled,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import jwt_decode from "jwt-decode";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_URL_ADDITIONAL_SETTINGS } from "../../actions/EndPoints";
import CustomDropdown from "../../components/CustomInputs/CustomDropdown";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CustomTextfields from "../../components/CustomInputs/CustomTextfields";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  createSettings,
  getListSettings,
  updateSettings,
} from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { listAllEmployees } from "../../slices/Employee/EmployeeSlice";
import { getDocuments } from "../../slices/NDA/NDASlice";
import { customerSubscription } from "../../slices/Subscription/SubscriptionSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import GlobalDataContext from "../GlobalDataContext";
import { digit, ScanLimit } from "../Person/AddressFormData";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  bottom: 5,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
}));

const CustomFormControlLabel = styled(FormControlLabel)(
  ({ theme, darkMode }) => ({
    "& .MuiFormControlLabel-label": {
      color: darkMode ? "#fff" : "#000", // Color for dark mode or light mode
    },
    "&.Mui-disabled .MuiFormControlLabel-label": {
      color: darkMode ? "#fff !important" : "#aaa !important", // Color when disabled in dark mode or light mode
    },
  }),
);

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const weeklyDays = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

const getCurrentMonthDays = () => {
  const today = new Date();
  const month = today.getMonth() + 1; // JS months are 0–11
  const year = today.getFullYear();

  const daysInMonth = new Date(year, month, 0).getDate();

  return Array.from({ length: daysInMonth }, (_, i) => ({
    label: `${i + 1}`,
    value: `${i + 1}`,
  }));
};

function AdditionalSettings() {
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );
  const monthlyDays = useMemo(() => getCurrentMonthDays(), []);
  const history = useHistory();
  const dispatch = useDispatch();
  const [featureList, setFeatureList] = useState([]);
  const { t } = useTranslation();
  const [Digit, setDigit] = React.useState([]);
  const [scanLimit, setScanLimit] = React.useState([]);
  const [employees, setEmployees] = useState([]);
  const [enableDLMobile, setEnableDLMobile] = useState(false);
  const [offenderFeature, setOffenderFeature] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const cardRangeFieldSx = {
    "& .MuiInputBase-input": {
      color: darkMode ? "#fff" : "#000",
      WebkitTextFillColor: darkMode ? "#fff" : "#000",
    },
    "& .MuiInputLabel-root": {
      color: darkMode ? "rgb(160, 158, 158)" : "rgba(0, 0, 0, 0.6)",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: darkMode ? "#576A7A" : "rgba(0, 0, 0, 0.23)",
    },
  };
  const { setCompanySettings } = useContext(GlobalDataContext);
  const [monthlyDate, setMonthlyDate] = useState(monthlyDays);
  const [valueOfRecurrenDays, setValueOfRecurrenDays] = useState(null);
  const { visitorEvents, setVisitorEvents } = useContext(ProfileContext);
  const [state, setState] = useState({
    id: "",
    companyId: decoded_jwtToken.userId,
    invitationApproval: true,
    walkInRegistartionApproval: true,
    selfRegistartionApproval: true,
    autoCheckOut: false,
    printerStatus: true,
    printerDevice: "Kiosk",
    invitationVerifyMode: "QRCODE",
    walkInRegistartionVerifyMode: "QRCODE",
    selfRegistartionVerifyMode: "QRCODE",
    invitationCodeDigits: "",
    walkInCodeDigits: "",
    selfRegistartionCodeDigits: "",
    invitationScanLimit: "",
    walkInScanLimit: "",
    selfRegistartionScanLimit: "",
    invitationIntervalTime: "30",
    walkInIntervalTime: "30",
    selfIntervalTime: "30",
    invitationEarlyCheckInTime: "30",
    invitationLateCheckOutTime: "30",
    walkInEarlyCheckInTime: "30",
    walkInLateCheckOutTime: "30",
    selfEarlyCheckInTime: "30",
    selfLateCheckOutTime: "30",
    dlScanMode: checked,
    dateFormat: "DD-MM-YYYY",
    badgePrint: checkBadgePrint,
    invitationPurposeType: false,
    invitationVisitorType: false,
    invitationSiteType: false,
    invitationCompanyName: false,
    invitationProfilePhoto: false,
    checkInvitationPurposeType: invitationPurposeTypeMandatory,
    checkInvitationVisitorType: invitationVisitorTypeMandatory,
    checkInvitationSiteType: invitationSiteTypeMandatory,
    checkInvitationCompanyName: invitationCompanyNameMandatory,
    checkInvitationProfilePhoto: invitationProfilePhotoMandatory,
    walkInRegistrationPurposeType: false,
    walkInRegistrationVisitorType: false,
    walkInRegistrationSiteType: false,
    wlakInRegistrationCompanyName: false,
    walkInRegistrationProfilePhoto: true,
    walkInRegistrationSignatureOnKiosk: false,
    checkWalkInRegistrationPurposeType: walkInPurposeTypeMandatory,
    checkWalkInRegistrationVisitorType: walkInVisitorTypeMandatory,
    checkWalkInRegistrationSiteType: walkInSiteTypeMandatory,
    checkWalkInRegistrationCompanyName: walkInCompanyNameMandatory,
    checkWalkInRegistrationProfilePhoto: WalkInProfilePhotoMandatory,
    checkWalkInRegistrationSignatureOnKiosk: WalkInSignatureMandatory,
    selfRegistrationPurposeType: false,
    selfRegistrationVisitorType: false,
    selfRgistrationSiteType: false,
    selfRegistrationCompanyName: false,
    selfRegistrationProfilePhoto: true,
    checkSelfRegistrationPurposeType: selfRegistrationPurposeTypeMandatory,
    checkSelfRegistrationVisitorType: selfRegistrationVisitorTypeMandatory,
    checkSelfRegistrationSiteType: selfRegistrationSiteTypeMandatory,
    checkSelfRegistrationCompanyName: selfRegistrationCompanyNameMandatory,
    checkSelfRegistrationProfilePhoto: selfRegistrationProfilePhotoMandatory,
    delivery: false,
    defaultHostId: null,
    defaultWalkInHostId: null,
    invitationBypass: true,
    walkInBypass: true,
    adminAndDealerDateFormat: "MM-DD-YYYY",
    walkInImageCapture: false,
    selfImageCapture: false,
    walkInImagesCaptureLimit: "",
    selfImagesCaptureLimit: "",
    walkInAutoContactInfo: false,
    selfAutoContactInfo: false,
    proxyDomain: "mysmartguardplus.com",
    offenderVerification: false,
    invitationNDA: false,
    walkInRegistrationNDA: false,
    selfRegistrationNDA: false,
    invitationNDANotification: false,
    walkInRegistrationNDANotification: false,
    selfRegistrationNDANotification: false,
    autoVisitorsReport: false,
    invitationReports: false,
    walkInRegistrationReports: false,
    selfRegistrationReports: false,
    receiverEmailIds: [],
    visitorsReportsFrequency: "",
    documentCapture: false,
    recurrenceDay: "",
    prismIntegration: false,
    invitationSafetyVideo: false,
    walkInSafetyVideo: false,
    selfRegistrationSafetyVideo: false,
    globalCardNumberMinRange: "",
    globalCardNumberMaxRange: "",
  });
  const [expanded, setExpanded] = React.useState("");
  const [scanMode, setScanMode] = useState("");
  const [checked, setChecked] = useState(false);
  const [checkBadgePrint, setCheckBadgePrint] = useState(false);
  const [walkInBypass, setWalkInBypass] = useState(true);
  const [invitationByPass, setInvitationByPass] = useState(true);
  const [
    invitationPurposeTypeMandatory,
    setInvitationPurposeTypeMandatory,
  ] = useState(false);
  const [
    invitationVisitorTypeMandatory,
    setInvitationVisitorTypeMandatory,
  ] = useState(false);
  const [
    invitationSiteTypeMandatory,
    setInvitationSiteTypeMandatory,
  ] = useState(false);
  const [
    invitationCompanyNameMandatory,
    setInvitationCompanyNameMandatory,
  ] = useState(false);
  const [
    invitationNDANotifictionMandatory,
    setInvitationNDANotificationMandatory,
  ] = useState(false);
  const [
    walkInNDANotifictionMandatory,
    setWalkInNDANotificationMandatory,
  ] = useState(false);
  const [
    invitationProfilePhotoMandatory,
    setInvitationProfilePhotoMandatory,
  ] = useState(false);
  const [walkInPurposeTypeMandatory, setWalkInPurposeTypeMandatory] = useState(
    false,
  );
  const [walkInVisitorTypeMandatory, setWalkInVisitorTypeMandatory] = useState(
    false,
  );
  const [walkInSiteTypeMandatory, setWalkInSiteTypeMandatory] = useState(false);
  const [walkInCompanyNameMandatory, setWalkInCompanyNameMandatory] = useState(
    false,
  );
  const [
    WalkInProfilePhotoMandatory,
    setWalkInProfilePhotoMandatory,
  ] = useState(true);
  const [WalkInSignatureMandatory, setWalkInSignatureMandatory] = useState(
    false,
  );
  const [
    selfRegistrationPurposeTypeMandatory,
    setSelfRegistrationPurposeTypeMandatory,
  ] = useState(false);
  const [
    selfRegistrationVisitorTypeMandatory,
    setSelfRegistrationVisitorTypeMandatory,
  ] = useState(false);
  const [
    selfRegistrationSiteTypeMandatory,
    setSelfRegistrationSiteTypeMandatory,
  ] = useState(false);
  const [
    selfRegistrationCompanyNameMandatory,
    setSelfRegistrationCompanyNameMandatory,
  ] = useState(false);
  const [
    selfRegistrationNDANotifictionMandatory,
    setSelfRegistrationNDANotifictionMandatory,
  ] = useState(false);
  const [
    selfRegistrationProfilePhotoMandatory,
    setSelfRegistrationProfilePhotoMandatory,
  ] = useState(true);
  const [selectedHost, setSelectedHost] = useState(null);
  const [selectedWalkIHost, setSelectedWalkInHost] = useState(null);
  const [ndaDocuments, setNdaDocuments] = useState([]);
  const [invitationReports, setInvitationReports] = useState(false);
  const [walkInRegistrationReports, setWalkInRegistrationReports] = useState(
    false,
  );
  const [selfRegistrationReports, setSelfRegistrationReports] = useState(false);
  const [receiverEmailIds, setReceiverEmailIds] = useState([]);
  const [emailError, setEmailError] = useState(false);
  const [documentCapture, setDocumentCapture] = useState(false);
  const handleChangeAccordian = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const captureLimit = [
    {
      id: "1",
      name: "1",
    },
    {
      id: "2",
      name: "2",
    },
    {
      id: "3",
      name: "3",
    },
    {
      id: "4",
      name: "4",
    },
    {
      id: "5",
      name: "5",
    },
  ];

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const handleNDAChange = (event) => {
    const { name, checked } = event.target;

    if (ndaDocuments.length === 0) {
      Toast("Please upload NDA Documents", "error");
      return;
    }

    setState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    if (!checked) {
      switch (name) {
        case "invitationNDA":
          setInvitationNDANotificationMandatory(false);
          break;
        case "walkInRegistrationNDA":
          setWalkInNDANotificationMandatory(false);
          break;
        case "selfRegistrationNDA":
          setSelfRegistrationNDANotifictionMandatory(false);
          break;
        default:
          break;
      }
    }
  };

  const handleProxyDomain = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
    setError(false);
  };

  const handlePrintDevice = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  const changeIntervalTime = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const [error, setError] = useState({
    invitationCodeDigits: false,
    walkInCodeDigits: false,
    selfRegistartionCodeDigits: false,
    invitationIntervalTime: false,
    walkInIntervalTime: false,
    selfIntervalTime: false,
    invitationEarlyCheckInTime: false,
    invitationLateCheckOutTime: false,
    walkInEarlyCheckInTime: false,
    walkInLateCheckOutTime: false,
    selfEarlyCheckInTime: false,
    selfLateCheckOutTime: false,
    proxyDomain: false,
    dateFormat: false,
    visitorsReportsFrequency: false,
    recurrenceDay: false,
    globalCardNumberMinRange: false,
    globalCardNumberMaxRange: false,
  });

  const handleChangeofDropdown = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleCardMin = (event) => {
    const { name, value } = event.target;
    let updatedError = { ...error };
    const maxField = name.replace("MinRange", "MaxRange");

    if (value && Number(value) < 1) {
      updatedError[name] = "Min must start from 1";
    } else if (state[maxField] && Number(value) > Number(state[maxField])) {
      updatedError[name] = "Min cannot be greater than Max";
    } else if (state[maxField] && Number(value) === Number(state[maxField])) {
      updatedError[name] = "Min and Max cannot be same";
    } else {
      updatedError[name] = "";
      if (updatedError[maxField] === "Min and Max cannot be same") {
        updatedError[maxField] = "";
      }
    }
    setState({
      ...state,
      [name]: value,
    });
    setError(updatedError);
  };

  const handleCardMax = (event) => {
    const { name, value } = event.target;
    let updatedError = { ...error };
    const minField = name.replace("MaxRange", "MinRange");
    if (value && Number(value) > 99999) {
      updatedError[name] = "Max cannot exceed 99999";
    } else if (state[minField] && Number(value) <= Number(state[minField])) {
      updatedError[name] = "Max cannot be less than or equal to Min";
    } else {
      updatedError[name] = "";
    }
    setError(updatedError);
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleChangeEamilIds = (e) => {
    const inputEmails = e.target.value;
    const emailArray = inputEmails
      .split(/[ ,;]+/)
      .filter((email) => email.trim() !== "");

    if (emailArray.length > 3) {
      setEmailError(t("ERROR_RECEIVER_EMAIL"));
      return;
    }
    setReceiverEmailIds(inputEmails);
    const regex = /\S+@\S+\.\S+/;
    if (inputEmails.trim() === "") {
      setEmailError("");
      setState((prevState) => ({
        ...prevState,
        receiverEmailIds: [],
      }));
      return;
    }
    let isValid = true;
    emailArray.forEach((email) => {
      if (!regex.test(email.trim())) {
        isValid = false;
      }
    });

    if (isValid) {
      setEmailError("");
      setState((prevState) => ({
        ...prevState,
        receiverEmailIds: emailArray,
      }));
    } else {
      setEmailError(t("EMAIL_INVAIL_ERROR"));
    }
  };

  const [filter, setFilter] = useState({
    firstName: "",
    email: "",
    phoneCountryCode: "",
    phone: "",
    code: "",
  });

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    setDigit(digit);
    setScanLimit(ScanLimit);
    loadNDADocuments();
    loadAdditionalSettings();
    loadData(filter, paging);
  }, []);

  const loadNDADocuments = () => {
    dispatch(getDocuments(localStorage.getItem("companyId")))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && data.data) {
          setNdaDocuments(data.data);
        } else {
          setNdaDocuments([]);
        }
      })
      .catch((er) => {});
  };

  const loadAdditionalSettings = () => {
    dispatch(getListSettings(state))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setState({
            ...state,
            id: data.data.id,
            companyId: data.data.companyId,
            invitationApproval: data.data.invitationApproval,
            walkInRegistartionApproval: data.data.walkInRegistartionApproval,
            selfRegistartionApproval: data.data.selfRegistartionApproval,
            printerStatus: data.data.printerStatus,
            printerDevice: data.data.printerDevice,
            invitationVerifyMode: data.data.invitationVerifyMode,
            walkInRegistartionVerifyMode:
              data.data.walkInRegistartionVerifyMode,
            selfRegistartionVerifyMode: data.data.selfRegistartionVerifyMode,
            invitationCodeDigits: data.data.invitationCodeDigits,
            invitationScanLimit: data.data.invitationScanLimit,
            walkInScanLimit: data.data.walkInScanLimit,
            selfRegistartionScanLimit: data.data.selfRegistartionScanLimit,
            walkInCodeDigits: data.data.walkInCodeDigits,
            selfRegistartionCodeDigits: data.data.selfRegistartionCodeDigits,
            invitationIntervalTime: data.data.invitationIntervalTime,
            walkInIntervalTime: data.data.walkInIntervalTime,
            selfIntervalTime: data.data.selfIntervalTime,
            invitationEarlyCheckInTime: data.data.invitationEarlyCheckInTime,
            invitationLateCheckOutTime: data.data.invitationLateCheckOutTime,
            walkInEarlyCheckInTime: data.data.walkInEarlyCheckInTime,
            walkInLateCheckOutTime: data.data.walkInLateCheckOutTime,
            selfEarlyCheckInTime: data.data.selfEarlyCheckInTime,
            selfLateCheckOutTime: data.data.selfLateCheckOutTime,
            delivery: data.data.delivery,
            dlScanMode: checked,
            dateFormat: data.data.dateFormat,
            badgePrint: checkBadgePrint,
            invitationPurposeType: data.data.invitationPurposeType,
            invitationVisitorType: data.data.invitationVisitorType,
            invitationSiteType: data.data.invitationSiteType,
            invitationCompanyName: data.data.invitationCompanyName,
            invitationNDAEnable: data.data.invitationNDAEnable,
            walkInRegistrationNDAEnable: data.data.walkInRegistrationNDAEnable,
            selfRegistrationNDAEnable: data.data.selfRegistrationNDAEnable,
            invitationProfilePhoto: data.data.invitationProfilePhoto,
            walkInRegistrationPurposeType:
              data.data.walkInRegistrationPurposeType,
            walkInRegistrationVisitorType:
              data.data.walkInRegistrationVisitorType,
            walkInRegistrationSiteType: data.data.walkInRegistrationSiteType,
            wlakInRegistrationCompanyName:
              data.data.wlakInRegistrationCompanyName,
            walkInRegistrationProfilePhoto:
              data.data.walkInRegistrationProfilePhoto,
            walkInRegistrationSignatureOnKiosk:
              data.data.walkInRegistrationSignatureOnKiosk,
            selfRegistrationPurposeType: data.data.selfRegistrationPurposeType,
            selfRegistrationVisitorType: data.data.selfRegistrationVisitorType,
            selfRgistrationSiteType: data.data.selfRgistrationSiteType,
            selfRegistrationCompanyName: data.data.selfRegistrationCompanyName,
            selfRegistrationProfilePhoto:
              data.data.selfRegistrationProfilePhoto,
            checkInvitationPurposeType: invitationPurposeTypeMandatory,
            checkInvitationVisitorType: invitationVisitorTypeMandatory,
            checkInvitationSiteType: invitationSiteTypeMandatory,
            checkInvitationCompanyName: invitationCompanyNameMandatory,
            checkInvitationNDANotification: invitationNDANotifictionMandatory,
            checkWalkInRegistrationNDANotification: walkInNDANotifictionMandatory,
            checkSelfRegistrationNDANotification: selfRegistrationNDANotifictionMandatory,
            checkInvitationProfilePhoto: invitationProfilePhotoMandatory,
            checkWalkInRegistrationPurposeType: walkInPurposeTypeMandatory,
            checkWalkInRegistrationVisitorType: walkInVisitorTypeMandatory,
            checkWalkInRegistrationSiteType: walkInSiteTypeMandatory,
            checkWalkInRegistrationCompanyName: walkInCompanyNameMandatory,
            checkWalkInRegistrationProfilePhoto: WalkInProfilePhotoMandatory,
            checkWalkInRegistrationSignatureOnKiosk: WalkInSignatureMandatory,
            checkSelfRegistrationPurposeType: selfRegistrationPurposeTypeMandatory,
            checkSelfRegistrationVisitorType: selfRegistrationVisitorTypeMandatory,
            checkSelfRegistrationSiteType: selfRegistrationSiteTypeMandatory,
            checkSelfRegistrationCompanyName: selfRegistrationCompanyNameMandatory,
            checkSelfRegistrationProfilePhoto: selfRegistrationProfilePhotoMandatory,
            defaultHostId: data.data.defaultHostId,
            defaultWalkInHostId: data.data.defaultWalkInHostId,
            invitationBypass: data.data.invitationBypass,
            walkInBypass: data.data.walkInBypass,
            viewedVersion: data.data.viewedVersion,
            walkInImageCapture: data.data.walkInImageCapture,
            selfImageCapture: data.data.selfImageCapture,
            walkInImagesCaptureLimit: data.data.walkInImagesCaptureLimit,
            selfImagesCaptureLimit: data.data.selfImagesCaptureLimit,
            walkInAutoContactInfo: data.data.walkInAutoContactInfo,
            selfAutoContactInfo: data.data.selfAutoContactInfo,
            proxyDomain: data.data.proxyDomain,
            offenderVerification: data.data.offenderVerification,
            userName: data.data.userName,
            password: data.data.password,
            prismAccessKey: data.data.prismAccessKey,
            propertyManagementId: data.data.propertyManagementId,
            propertyId: data.data.propertyId,
            issueTypeId: data.data.issueTypeId,
            issueTypeName: data.data.issueTypeName,
            invitationNDA: data.data.invitationNDA,
            walkInRegistrationNDA: data.data.walkInRegistrationNDA,
            selfRegistrationNDA: data.data.selfRegistrationNDA,
            invitationNDANotification: invitationNDANotifictionMandatory,
            walkInRegistrationNDANotification: walkInNDANotifictionMandatory,
            selfRegistrationNDANotification: selfRegistrationNDANotifictionMandatory,
            autoVisitorsReport: data.data.autoVisitorsReport,
            invitationReports: invitationReports,
            walkInRegistrationReports: walkInRegistrationReports,
            selfRegistrationReports: selfRegistrationReports,
            receiverEmailIds: data.data.receiverEmailIds,
            visitorsReportsFrequency: data.data.visitorsReportsFrequency,
            documentCapture: data.data.documentCapture,
            autoCheckOut: data.data.autoCheckOut,
            recurrenceDay: data.data.recurrenceDay,
            prismIntegration: data.data.prismIntegration,
            invitationSafetyVideo: data.data.invitationSafetyVideo,
            walkInSafetyVideo: data.data.walkInSafetyVideo,
            selfRegistrationSafetyVideo: data.data.selfRegistrationSafetyVideo,
            globalCardNumberMinRange: data.data.globalCardNumberMinRange,
            globalCardNumberMaxRange: data.data.globalCardNumberMaxRange,
          });
          setChecked(data.data.dlScanMode);
          setReceiverEmailIds(data.data.receiverEmailIds);
          setCheckBadgePrint(data.data.badgePrint);
          setInvitationByPass(data.data.invitationBypass);
          setWalkInBypass(data.data.walkInBypass);
          setInvitationPurposeTypeMandatory(
            data.data.checkInvitationPurposeType,
          );
          setInvitationVisitorTypeMandatory(
            data.data.checkInvitationVisitorType,
          );
          setInvitationSiteTypeMandatory(data.data.checkInvitationSiteType);
          setInvitationCompanyNameMandatory(
            data.data.checkInvitationCompanyName,
          );

          setInvitationProfilePhotoMandatory(
            data.data.checkInvitationProfilePhoto,
          );
          setWalkInPurposeTypeMandatory(
            data.data.checkWalkInRegistrationPurposeType,
          );
          setWalkInVisitorTypeMandatory(
            data.data.checkWalkInRegistrationVisitorType,
          );
          setWalkInSiteTypeMandatory(data.data.checkWalkInRegistrationSiteType);
          setWalkInCompanyNameMandatory(
            data.data.checkWalkInRegistrationCompanyName,
          );
          setWalkInProfilePhotoMandatory(
            data.data.checkWalkInRegistrationProfilePhoto,
          );
          setWalkInSignatureMandatory(
            data.data.checkWalkInRegistrationSignatureOnKiosk,
          );
          setSelfRegistrationPurposeTypeMandatory(
            data.data.checkSelfRegistrationPurposeType,
          );
          setSelfRegistrationVisitorTypeMandatory(
            data.data.checkSelfRegistrationVisitorType,
          );
          setSelfRegistrationCompanyNameMandatory(
            data.data.checkSelfRegistrationCompanyName,
          );
          setSelfRegistrationSiteTypeMandatory(
            data.data.checkSelfRegistrationSiteType,
          );
          setSelfRegistrationProfilePhotoMandatory(
            data.data.checkSelfRegistrationProfilePhoto,
          );
          setInvitationNDANotificationMandatory(
            data.data.invitationNDANotification,
          );
          setWalkInNDANotificationMandatory(
            data.data.walkInRegistrationNDANotification,
          );
          setSelfRegistrationNDANotifictionMandatory(
            data.data.selfRegistrationNDANotification,
          );
          setInvitationReports(data.data.invitationReports);
          setWalkInRegistrationReports(data.data.walkInRegistrationReports);
          setSelfRegistrationReports(data.data.selfRegistrationReports);
          if (CommonUtil.isEmpty(data.data?.invitationCodeDigits)) {
            setQrCode(true);
            setDigitCode(false);
          } else {
            setDigitCode(true);
            setQrCode(false);
          }
          if (CommonUtil.isEmpty(data.data?.walkInCodeDigits)) {
            setQrCode1(true);
            setDigitCode1(false);
          } else {
            setDigitCode1(true);
            setQrCode1(false);
          }
          if (CommonUtil.isEmpty(data.data?.selfRegistartionCodeDigits)) {
            setQrCode2(true);
            setDigitCode2(false);
          } else {
            setDigitCode2(true);

            setQrCode2(false);
          }
        }
      })
      .catch((er) => {});
  };

  const loadData = (filter, paging) => {
    dispatch(listAllEmployees(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "OMSI0000" && data.data)) {
          setEmployees(data.data.employees);
        } else {
          setEmployees([]);
        }
      })
      .catch((er) => {});
  };

  useEffect(() => {
    const host = employees.find((host) => host.id === state.defaultHostId);
    if (host?.id) setSelectedHost(host);
  }, [employees, state.id]);

  useEffect(() => {
    const host = employees.find(
      (host) => host.id === state.defaultWalkInHostId,
    );
    if (host?.id) setSelectedWalkInHost(host);
  }, [employees, state.id]);

  const handleSubmit = () => {
    if (digitCode && CommonUtil.isEmpty(state.invitationCodeDigits)) {
      Toast(t("Enter Invitation Digit Code"), "error");
      setError({ invitationCodeDigits: true });
      return;
    }
    if (digitCode1 && CommonUtil.isEmpty(state.walkInCodeDigits)) {
      Toast(t("Enter walkIn Code Digits"), "error");
      setError({ walkInCodeDigits: true });
      return;
    }
    if (digitCode2 && CommonUtil.isEmpty(state.selfRegistartionCodeDigits)) {
      Toast(t("Enter self Registartion Code Digits"), "error");
      setError({ selfRegistartionCodeDigits: true });
      return;
    }
    if (CommonUtil.isEmpty(state.invitationIntervalTime)) {
      Toast(t("Enter Invitation Interval Time"), "error");
      setError({ invitationIntervalTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.walkInIntervalTime)) {
      Toast(t("Enter Walk-In Interval Time"), "error");
      setError({ walkInIntervalTime: true });
      return;
    }
    if (qrCode && state.invitationScanLimit === "") {
      Toast("Invitation Scan Limit cannot be empty", "error");
      return;
    }
    if (qrCode1 && state.walkInScanLimit === "") {
      Toast("WalkIn Scan Limit cannot be empty", "error");
      return;
    }
    if (qrCode2 && state.selfRegistartionScanLimit === "") {
      Toast("Self Registration Scan Limit cannot be empty", "error");
      return;
    }
    if (state.invitationScanLimit === "0") {
      Toast("Invitation Scan Limit Can not be zero", "error");
      return;
    }
    if (state.walkInScanLimit === "0") {
      Toast("Walk-In Registration Scan Limit Can not be zero", "error");
      return;
    }
    if (state.selfRegistartionScanLimit === "0") {
      Toast("Self Registartion ScanLimit Can not be zero", "error");
      return;
    }
    if (CommonUtil.isEmpty(state.selfIntervalTime)) {
      Toast(t("Enter Self Registration Interval Time"), "error");
      setError({ selfIntervalTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.invitationEarlyCheckInTime)) {
      Toast(t("Enter Invitation Early Check-In Time"), "error");
      setError({ invitationEarlyCheckInTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.invitationLateCheckOutTime)) {
      Toast(t("Enter Invitation Late Check-Out Time"), "error");
      setError({ invitationLateCheckOutTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.walkInEarlyCheckInTime)) {
      Toast(t("Enter Walk-In Registration Early Check-In Time"), "error");
      setError({ walkInEarlyCheckInTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.walkInLateCheckOutTime)) {
      Toast(t("Enter Walk-In Registration Late Check-Out Time"), "error");
      setError({ walkInLateCheckOutTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.selfEarlyCheckInTime)) {
      Toast(t("Enter Self Registration Early Check-In Time"), "error");
      setError({ selfEarlyCheckInTime: true });
      return;
    }
    if (CommonUtil.isEmpty(state.selfLateCheckOutTime)) {
      Toast(t("Enter  Self Registration Late Check-Out Time"), "error");
      setError({ selfLateCheckOutTime: true });
      return;
    }
    if (state.walkInImageCapture && state.walkInImagesCaptureLimit === 0) {
      Toast(t("WalkIn images capture limit cannot be empty"), "error");
      return;
    }
    if (state.selfImageCapture && state.selfImagesCaptureLimit === 0) {
      Toast(
        t("SelfRegistration  images capture limit cannot be empty"),
        "error",
      );
      return;
    }
    if (CommonUtil.isEmpty(state.proxyDomain)) {
      Toast(t("Proxy domain is required"), "error");
      setError({ proxyDomain: true });
      return;
    }
    if (!CommonUtil.isValidDomain(state.proxyDomain)) {
      Toast(t("Enter valid domain"), "error");
      setError({ proxyDomain: true });
      return;
    }
    if (CommonUtil.isEmpty(state.dateFormat)) {
      Toast(t("Please select date format"), "error");
      setError({ dateFormat: true });
      return;
    }

    const min = state.globalCardNumberMinRange;
    const max = state.globalCardNumberMaxRange;

    if (!min || Number(min) <= 0) {
      Toast(t("Please set card number range of min"), "error");
      setError((prev) => ({
        ...prev,
        globalCardNumberMinRange: true,
      }));
      return;
    }

    if (!max || Number(max) <= 0) {
      Toast(t("Please set card number range of max"), "error");
      setError((prev) => ({
        ...prev,
        globalCardNumberMaxRange: true,
      }));
      return;
    }

    if (error.globalCardNumberMaxRange || error.globalCardNumberMinRange) {
      Toast("Please fix card number range error", "error");
      return;
    }
    if (state.autoVisitorsReport) {
      if (
        !state.invitationReports &&
        !state.walkInRegistrationReports &&
        !state.selfRegistrationReports
      ) {
        Toast(t("AUTO_ERR_MODE"), "error");
        return;
      } else if (
        !state.receiverEmailIds ||
        state.receiverEmailIds.length === 0
      ) {
        Toast(t("AUTO_ERR_RECEIVE"), "error");
        setEmailError(true);
        return;
      } else if (CommonUtil.isEmpty(state.visitorsReportsFrequency)) {
        setError({ visitorsReportsFrequency: true });
        Toast(t("AUTO_ERR_FREQUENCY"), "error");
        return;
      } else if (
        !CommonUtil.isEmpty(state.visitorsReportsFrequency) &&
        CommonUtil.isEmpty(state.recurrenceDay)
      ) {
        if (state.visitorsReportsFrequency === "Weekly") {
          Toast(t("AUTO_ERR_RECURRENCEDAY_WEEKLY"), "error");
          setError({ recurrenceDay: true });
          return;
        } else {
          Toast(t("AUTO_ERR_RECURRENCEDAY_MONTHLY"), "error");
          setError({ recurrenceDay: true });
          return;
        }
      }
      setEmailError("");
    }
    if (CommonUtil.isEmptyString(state.id)) {
      var requestBody = {
        companyId: decoded_jwtToken.companyId,
        invitationApproval: state.invitationApproval,
        walkInRegistartionApproval: state.walkInRegistartionApproval,
        selfRegistartionApproval: state.selfRegistartionApproval,
        printerStatus: state.printerStatus,
        printerDevice: state.printerDevice,
        invitationVerifyMode: state.invitationVerifyMode,
        walkInRegistartionVerifyMode: state.walkInRegistartionVerifyMode,
        selfRegistartionVerifyMode: state.selfRegistartionVerifyMode,
        invitationCodeDigits: state.invitationCodeDigits,
        invitationScanLimit: state.invitationScanLimit,
        walkInScanLimit: state.walkInScanLimit,
        selfRegistartionScanLimit: state.selfRegistartionScanLimit,
        walkInCodeDigits: state.walkInCodeDigits,
        selfRegistartionCodeDigits: state.selfRegistartionCodeDigits,
        invitationIntervalTime: state.invitationIntervalTime,
        walkInIntervalTime: state.walkInIntervalTime,
        selfIntervalTime: state.selfIntervalTime,
        invitationEarlyCheckInTime: state.invitationEarlyCheckInTime,
        invitationLateCheckOutTime: state.invitationLateCheckOutTime,
        walkInEarlyCheckInTime: state.walkInEarlyCheckInTime,
        walkInLateCheckOutTime: state.walkInLateCheckOutTime,
        selfEarlyCheckInTime: state.selfEarlyCheckInTime,
        selfLateCheckOutTime: state.selfLateCheckOutTime,
        dlScanMode: checked,
        dateFormat: state.dateFormat,
        badgePrint: checkBadgePrint,
        invitationPurposeType: state.invitationPurposeType,
        invitationVisitorType: state.invitationVisitorType,
        invitationSiteType: state.invitationSiteType,
        invitationCompanyName: state.invitationCompanyName,
        invitationNDAEnable: state.invitationNDAEnable,
        walkInRegistrationNDAEnable: state.walkInRegistrationNDAEnable,
        selfRegistrationNDAEnable: state.selfRegistrationNDAEnable,
        invitationProfilePhoto: state.invitationProfilePhoto,
        walkInRegistrationPurposeType: state.walkInRegistrationPurposeType,
        walkInRegistrationVisitorType: state.walkInRegistrationVisitorType,
        walkInRegistrationSiteType: state.walkInRegistrationSiteType,
        wlakInRegistrationCompanyName: state.wlakInRegistrationCompanyName,
        walkInRegistrationProfilePhoto: state.walkInRegistrationProfilePhoto,
        walkInRegistrationSignatureOnKiosk:
          state.walkInRegistrationSignatureOnKiosk,
        selfRegistrationPurposeType: state.selfRegistrationPurposeType,
        selfRegistrationVisitorType: state.selfRegistrationVisitorType,
        selfRgistrationSiteType: state.selfRgistrationSiteType,
        selfRegistrationCompanyName: state.selfRegistrationCompanyName,
        selfRegistrationProfilePhoto: state.selfRegistrationProfilePhoto,
        checkInvitationPurposeType: invitationPurposeTypeMandatory,
        checkInvitationVisitorType: invitationVisitorTypeMandatory,
        checkInvitationSiteType: invitationSiteTypeMandatory,
        checkInvitationCompanyName: invitationCompanyNameMandatory,
        checkInvitationNDANotification: invitationNDANotifictionMandatory,
        checkWalkInRegistrationNDANotification: walkInNDANotifictionMandatory,
        checkSelfRegistrationNDANotification: selfRegistrationNDANotifictionMandatory,
        checkInvitationProfilePhoto: invitationProfilePhotoMandatory,
        checkWalkInRegistrationPurposeType: walkInPurposeTypeMandatory,
        checkWalkInRegistrationVisitorType: walkInVisitorTypeMandatory,
        checkWalkInRegistrationSiteType: walkInSiteTypeMandatory,
        checkWalkInRegistrationCompanyName: walkInCompanyNameMandatory,
        checkWalkInRegistrationProfilePhoto: WalkInProfilePhotoMandatory,
        checkWalkInRegistrationSignatureOnKiosk: WalkInSignatureMandatory,
        checkSelfRegistrationPurposeType: selfRegistrationPurposeTypeMandatory,
        checkSelfRegistrationVisitorType: selfRegistrationVisitorTypeMandatory,
        checkSelfRegistrationSiteType: selfRegistrationSiteTypeMandatory,
        checkSelfRegistrationCompanyName: selfRegistrationCompanyNameMandatory,
        checkSelfRegistrationProfilePhoto: selfRegistrationProfilePhotoMandatory,
        delivery: state.delivery,
        defaultHostId: state.defaultHostId,
        defaultWalkInHostId: state.defaultWalkInHostId,
        invitationByPass: state.invitationBypass,
        walkInBypass: state.walkInBypass,
        adminAndDealerDateFormat: "MM-DD-YYYY",
        walkInImageCapture: state.walkInImageCapture,
        selfImageCapture: state.selfImageCapture,
        walkInImagesCaptureLimit: state.walkInImagesCaptureLimit,
        selfImagesCaptureLimit: state.selfImagesCaptureLimit,
        walkInAutoContactInfo: state.walkInAutoContactInfo,
        selfAutoContactInfo: state.selfAutoContactInfo,
        invitationSafetyVideo: state.invitationSafetyVideo,
        walkInSafetyVideo: state.walkInSafetyVideo,
        selfRegistrationSafetyVideo: state.selfRegistrationSafetyVideo,
        globalCardNumberMinRange: state.globalCardNumberMinRange,
        globalCardNumberMaxRange: state.globalCardNumberMaxRange,
      };
      console.log("Create" + requestBody);

      if (
        state.invitationIntervalTime == 0 ||
        state.walkInIntervalTime == 0 ||
        state.selfIntervalTime == 0
      ) {
        Toast(t("Interval Time Cannot be Zero"), "error");
      } else {
        dispatch(createSettings(requestBody))
          .unwrap()
          .then((data) => {
            if (data.code === "CVAI0063") {
              setCompanySettings(data.data);
              localStorage.setItem(
                "companySettings",
                JSON.stringify(data.data),
              );
              setVisitorEvents(data.data.autoCheckOut);
              Toast("Settings created successfully", "success");
              history.push(REACT_URL_ADDITIONAL_SETTINGS);
            } else if (data.code === "CVAI0064") {
              Toast("Settings already present", "error");
              setCompanySettings(data.data);
              localStorage.setItem(
                "companySettings",
                JSON.stringify(data.data),
              );
              setVisitorEvents(data.data.autoCheckOut);
              history.push(REACT_URL_ADDITIONAL_SETTINGS);
            } else {
              Toast(data.message, "error");
            }
            history.push(REACT_URL_ADDITIONAL_SETTINGS);
          });
      }
    } else {
      if (
        state.invitationIntervalTime == 0 ||
        state.walkInIntervalTime == 0 ||
        state.selfIntervalTime == 0
      ) {
        Toast(t("Interval Time Cannot be Zero"), "error");
      } else {
        dispatch(updateSettings(state))
          .unwrap()
          .then((data) => {
            if (data.code === "CVAI0071") {
              Toast(data.message, "success");
              setCompanySettings(data.data);
              localStorage.setItem(
                "companySettings",
                JSON.stringify(data.data),
              );
              setVisitorEvents(data.data.autoCheckOut);
            } else if (data.code === "CVAW0064") {
              Toast("Settings already present", "error");
              setCompanySettings(data.data);
              localStorage.setItem(
                "companySettings",
                JSON.stringify(data.data),
              );
              setVisitorEvents(data.data.autoCheckOut);
            } else {
              Toast(data.message, "error");
            }
          })
          .catch((er) => {});
      }
    }
  };

  const [qrCode, setQrCode] = useState(true);
  const [digitCode, setDigitCode] = useState(false);

  const [qrCode1, setQrCode1] = useState(true);
  const [digitCode1, setDigitCode1] = useState(false);

  const [qrCode2, setQrCode2] = useState(true);
  const [digitCode2, setDigitCode2] = useState(false);

  const [deliveryPermission, setDeliveryPermission] = useState(false);

  const handleChangeQR = (event) => {
    setError({ invitationCodeDigits: false });
    setQrCode(true);
    setDigitCode(false);
    setState({
      ...state,
      invitationCodeDigits: "",
      invitationVerifyMode: "QRCODE",
    });
  };

  const handleChangeDigit = (event) => {
    setQrCode(false);
    setDigitCode(true);
    setState({
      ...state,
      invitationCodeDigits: "6",
      invitationVerifyMode: "PASSCODE",
      invitationScanLimit: "2",
    });
  };
  const handleChangeQR1 = (event) => {
    setError({ walkInCodeDigits: false });
    setQrCode1(true);
    setDigitCode1(false);
    setState({
      ...state,
      walkInCodeDigits: "",
      walkInRegistartionVerifyMode: "QRCODE",
    });
  };

  const handleImageCapture = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.checked,
    });
  };

  const handleWalkInAutoContactInfo = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.checked,
    });
  };

  const handleSelfAutoContactInfo = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.checked,
    });
  };

  const handleAutoReport = (e) => {
    const { name, checked } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleChangeDigit1 = (event) => {
    setQrCode1(false);
    setDigitCode1(true);
    setState({
      ...state,
      walkInCodeDigits: "6",
      walkInRegistartionVerifyMode: "PASSCODE",
      walkInScanLimit: "2",
    });
  };

  const handleChangeQR2 = (event) => {
    setError({ selfRegistartionCodeDigits: false });
    setQrCode2(true);
    setDigitCode2(false);
    setState({
      ...state,
      selfRegistartionCodeDigits: "",
      selfRegistartionVerifyMode: "QRCODE",
    });
  };
  const handleChangeDigit2 = (event) => {
    setQrCode2(false);
    setDigitCode2(true);
    setState({
      ...state,
      selfRegistartionCodeDigits: "6",
      selfRegistartionVerifyMode: "PASSCODE",
      selfRegistartionScanLimit: "2",
    });
  };

  const handleCheckBox = (event) => {
    setChecked(!checked);
  };

  const handleBadgePrint = (event) => {
    setCheckBadgePrint(!checkBadgePrint);
  };

  const handleWalkInBypass = (event) => {
    setWalkInBypass(!walkInBypass);
    setState({
      ...state,
      walkInBypass: event.target.checked,
      walkInRegistrationNDA:
        event.target.checked === false
          ? event.target.checked
          : state.walkInRegistrationNDA,
      walkInRegistrationNDANotification:
        event.target.checked === false
          ? event.target.checked
          : state.walkInRegistrationNDANotification,
    });
  };

  const handleInvitationBypass = (event) => {
    setInvitationByPass(!invitationByPass);
    setState({
      ...state,
      invitationBypass: event.target.checked,
      invitationNDA:
        event.target.checked === false
          ? event.target.checked
          : state.invitationNDA,
      invitationNDANotification:
        event.target.checked === false
          ? event.target.checked
          : state.invitationNDANotification,
      invitationSafetyVideo:
        event.target.checked === false
          ? event.target.checked
          : state.invitationSafetyVideo,
    });
  };

  useEffect(() => {
    setState({
      ...state,
      dlScanMode: checked,
    });
  }, [checked]);

  useEffect(() => {
    setState({
      ...state,
      badgePrint: checkBadgePrint,
    });
  }, [checkBadgePrint]);

  const handleCheckBoxInvitationPurposeType = () => {
    setInvitationPurposeTypeMandatory(!invitationPurposeTypeMandatory);
  };

  const handleCheckBoxInvitationVisitorType = () => {
    setInvitationVisitorTypeMandatory(!invitationVisitorTypeMandatory);
  };

  const handleCheckBoxInvitationSiteType = () => {
    setInvitationSiteTypeMandatory(!invitationSiteTypeMandatory);
  };

  const handleCheckBoxInvitationCompanyName = () => {
    setInvitationCompanyNameMandatory(!invitationCompanyNameMandatory);
  };

  const handleCheckBoxInvitationNDANotification = () => {
    setInvitationNDANotificationMandatory(!invitationNDANotifictionMandatory);
  };

  const handleCheckBoxWalkInNDANotification = () => {
    setWalkInNDANotificationMandatory(!walkInNDANotifictionMandatory);
  };

  const handleCheckBoxSelfRegistrationNDANotification = () => {
    setSelfRegistrationNDANotifictionMandatory(
      !selfRegistrationNDANotifictionMandatory,
    );
  };

  const handleCheckBoxInvitationProfilePhoto = () => {
    setInvitationProfilePhotoMandatory(!invitationProfilePhotoMandatory);
  };

  const handleCheckBoxWalkInPurposeType = () => {
    setWalkInPurposeTypeMandatory(!walkInPurposeTypeMandatory);
  };
  const handleCheckBoxWalkInVisitorType = () => {
    setWalkInVisitorTypeMandatory(!walkInVisitorTypeMandatory);
  };
  const handleCheckBoxWalkInSiteType = () => {
    setWalkInSiteTypeMandatory(!walkInSiteTypeMandatory);
  };
  const handleCheckBoxWalkInCompanyName = () => {
    setWalkInCompanyNameMandatory(!walkInCompanyNameMandatory);
  };
  const handleCheckBoxWalkInProfilePhoto = () => {
    setWalkInProfilePhotoMandatory(!WalkInProfilePhotoMandatory);
  };

  const handleCheckBoxSelfPurposeType = () => {
    setSelfRegistrationPurposeTypeMandatory(
      !selfRegistrationPurposeTypeMandatory,
    );
  };

  const handleCheckBoxSelfVisitorType = () => {
    setSelfRegistrationVisitorTypeMandatory(
      !selfRegistrationVisitorTypeMandatory,
    );
  };

  const handleCheckBoxSelfSiteType = () => {
    setSelfRegistrationSiteTypeMandatory(!selfRegistrationSiteTypeMandatory);
  };
  const handleCheckBoxSelfCompanyName = () => {
    setSelfRegistrationCompanyNameMandatory(
      !selfRegistrationCompanyNameMandatory,
    );
  };

  const handleCheckBoxSelfProfilePhoto = () => {
    setSelfRegistrationProfilePhotoMandatory(
      !selfRegistrationProfilePhotoMandatory,
    );
  };

  const handleCheckBoxSignature = () => {
    setWalkInSignatureMandatory(!WalkInSignatureMandatory);
  };

  const handleCheckBoxAutoReportInvitation = () => {
    setInvitationReports(!invitationReports);
  };
  const handleCheckBoxAutoReportWalkIn = () => {
    setWalkInRegistrationReports(!walkInRegistrationReports);
  };
  const handleCheckBoxAutoReportSelf = () => {
    setSelfRegistrationReports(!selfRegistrationReports);
  };

  useEffect(() => {
    setState({
      ...state,
      checkInvitationPurposeType: invitationPurposeTypeMandatory,
      checkInvitationVisitorType: invitationVisitorTypeMandatory,
      checkInvitationSiteType: invitationSiteTypeMandatory,
      checkInvitationCompanyName: invitationCompanyNameMandatory,
      checkInvitationProfilePhoto: invitationProfilePhotoMandatory,
      invitationNDANotification: invitationNDANotifictionMandatory,
      invitationReports: invitationReports,
    });
  }, [
    invitationPurposeTypeMandatory,
    invitationVisitorTypeMandatory,
    invitationSiteTypeMandatory,
    invitationCompanyNameMandatory,
    invitationNDANotifictionMandatory,
    invitationProfilePhotoMandatory,
    invitationReports,
  ]);

  useEffect(() => {
    setState({
      ...state,
      checkWalkInRegistrationPurposeType: walkInPurposeTypeMandatory,
      checkWalkInRegistrationVisitorType: walkInVisitorTypeMandatory,
      checkWalkInRegistrationSiteType: walkInSiteTypeMandatory,
      checkWalkInRegistrationCompanyName: walkInCompanyNameMandatory,
      checkWalkInRegistrationProfilePhoto: WalkInProfilePhotoMandatory,
      checkWalkInRegistrationSignatureOnKiosk: WalkInSignatureMandatory,
      walkInRegistrationNDANotification: walkInNDANotifictionMandatory,
      walkInRegistrationReports: walkInRegistrationReports,
    });
  }, [
    walkInPurposeTypeMandatory,
    walkInVisitorTypeMandatory,
    walkInSiteTypeMandatory,
    walkInCompanyNameMandatory,
    WalkInProfilePhotoMandatory,
    WalkInSignatureMandatory,
    walkInNDANotifictionMandatory,
    walkInRegistrationReports,
  ]);

  useEffect(() => {
    setState({
      ...state,
      checkSelfRegistrationPurposeType: selfRegistrationPurposeTypeMandatory,
      checkSelfRegistrationVisitorType: selfRegistrationVisitorTypeMandatory,
      checkSelfRegistrationSiteType: selfRegistrationSiteTypeMandatory,
      checkSelfRegistrationCompanyName: selfRegistrationCompanyNameMandatory,
      checkSelfRegistrationProfilePhoto: selfRegistrationProfilePhotoMandatory,
      selfRegistrationNDANotification: selfRegistrationNDANotifictionMandatory,
      selfRegistrationReports: selfRegistrationReports,
    });
  }, [
    selfRegistrationPurposeTypeMandatory,
    selfRegistrationVisitorTypeMandatory,
    selfRegistrationSiteTypeMandatory,
    selfRegistrationCompanyNameMandatory,
    selfRegistrationProfilePhotoMandatory,
    selfRegistrationNDANotifictionMandatory,
    selfRegistrationReports,
  ]);

  useEffect(() => {
    let payload = {
      companyId: decoded_jwtToken.companyId,
    };
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      dispatch(customerSubscription(payload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            const featureNames = res.data.data.feature.map(
              (feature) => feature.name,
            );
            setFeatureList(featureNames);
          }
        });
    }
  }, []);

  useEffect(() => {
    const normalizedFeatureList = featureList.map((feature) => {
      if (feature === "Checklist") {
        return "Checklist";
      }
      if (feature === "Watchlist") {
        return "Watchlist";
      }
      if (feature === "Offender Verification") {
        return "Offender";
      }
      if (
        feature === "Walk-In Registration through DL & Passport Scanner on Web"
      ) {
        return "Walk-In Registration";
      }
      return feature;
    });
    if (normalizedFeatureList.length !== 0) {
      normalizedFeatureList.forEach((item) => {
        if (item === "Delivery Report") {
          setDeliveryPermission(true);
        }
        if (item === "Walk-In Registration through DL on Mobile Application") {
          setEnableDLMobile(true);
        }
        if (item === "Offender") {
          setOffenderFeature(true);
        }
        if (item === "Walk-In Registration") {
          setDocumentCapture(true);
        }
      });
    }
  }, [featureList]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleChangeInvitationPurposeType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setInvitationPurposeTypeMandatory(false);
  };

  const handleChangeInvitationVisitorType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setInvitationVisitorTypeMandatory(false);
  };

  const handleChangeInvitationCompanyName = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setInvitationCompanyNameMandatory(false);
  };

  const handleChangeInvitationProfilePhoto = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setInvitationProfilePhotoMandatory(false);
  };

  const handleChangeInvitationSiteType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setInvitationSiteTypeMandatory(false);
  };

  //handle change for walkIn
  const handleChangeWalkInProfilePhoto = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setWalkInProfilePhotoMandatory(false);
  };

  const handleChangeWalkInPurposeType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setWalkInPurposeTypeMandatory(false);
  };

  const handleChangeWalkInVisitorType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setWalkInVisitorTypeMandatory(false);
  };

  const handleChangeWalkInCompanyName = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setWalkInCompanyNameMandatory(false);
  };

  const handleChangeWalkInSiteType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setWalkInSiteTypeMandatory(false);
  };

  const handleChangeWalkInSignature = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setWalkInSignatureMandatory(false);
  };

  //handle change for self

  const handleChangeSelfProfilePhoto = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setSelfRegistrationProfilePhotoMandatory(false);
  };

  const handleChangeSelfPurposeType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setSelfRegistrationPurposeTypeMandatory(false);
  };

  const handleChangeSelfVisitorType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setSelfRegistrationVisitorTypeMandatory(false);
  };

  const handleChangeSelfCompanyName = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setSelfRegistrationCompanyNameMandatory(false);
  };

  const handleChangeSelfSiteType = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    setSelfRegistrationSiteTypeMandatory(false);
  };
  const dateFormats = [
    { label: "DD-MM-YYYY", value: "dd-MM-yyyy" },
    { label: "MM-DD-YYYY", value: "MM-dd-yyyy" },
    { label: "YYYY-MM-DD", value: "yyyy-MM-dd" },
  ];

  const formatMapping = {
    "DD-MM-YYYY": "dd-MM-yyyy",
    "MM-DD-YYYY": "MM-dd-yyyy",
    "YYYY-MM-DD": "yyyy-MM-dd",
  };

  const handleDataFormat = (event, newValue) => {
    if (newValue === null) {
      setState({
        ...state,
        dateFormat: "",
      });
    } else {
      const backendFormat = formatMapping[newValue.label];
      setState({
        ...state,
        dateFormat: backendFormat || "",
      });
    }
  };

  const handleSelection = (event, value) => {
    if (value) {
      setSelectedHost(value);
      setState({
        ...state,
        defaultHostId: value.id,
      });
    } else {
      setState({
        ...state,
        defaultHostId: "",
      });
      setSelectedHost();
    }
  };

  const handleSelectionForWalkInHost = (event, value) => {
    if (value) {
      setSelectedWalkInHost(value);
      setState({
        ...state,
        defaultWalkInHostId: value.id,
      });
    } else {
      setState({
        ...state,
        defaultWalkInHostId: "",
      });
      setSelectedWalkInHost();
    }
  };

  const handleCancel = () => {
    loadAdditionalSettings();
  };
  useEffect(() => {
    const options =
      state.visitorsReportsFrequency === "Weekly" ? weeklyDays : monthlyDate;
    const selected =
      options.find((item) => item.value === state.recurrenceDay) || null;
    setValueOfRecurrenDays(selected);
  }, [state.visitorsReportsFrequency, state.recurrenceDay, monthlyDate]);

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ p: 2, paddingTop: "0px" }}>
          <Typography
            variant="h3"
            style={{
              marginRight: "5px",
              color: darkMode ? "#fff" : "#3D4977",
              marginLeft: "-15px",
            }}
          >
            {t("ADDSETTINGS")}
          </Typography>
        </Box>
      </Grid>
      <Box
        sx={{
          height: "calc(100vh - 150px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          style={{
            flex: 1,
            overflow: "hidden",
            height: "100%",
            backgroundColor: darkMode ? "#0E2A41" : "",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Scrollable content */}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
            }}
          >
            <PerfectScrollbar
              options={{ wheelPropagation: true }}
              style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
            >
              <Grid
                sx={{ width: { xs: "100%", flex: 1 } }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "30px",
                  backgroundColor: darkMode ? "#0E2A41" : "#fff",
                  flex: 1,
                }}
              >
                <FormControl component="fieldset" variant="standard">
                  <FormLabel
                    component="legend"
                    className={darkMode ? "AddtionalTitle1" : "AddtionalTitle"}
                  >
                    {t("APPRMODE")} {t("APPRMODE1")}
                  </FormLabel>
                  <br />
                  <FormGroup>
                    <Grid style={{ display: "flex", marginBottom: "20px" }}>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("labelDashBoardTotalReschedule2")}
                        </FormLabel>
                        <Android12Switch
                          checked={state.invitationApproval}
                          onChange={handleChange}
                          name="invitationApproval"
                          mode={darkMode}
                        />
                      </Grid>
                    </Grid>
                    <Grid style={{ display: "flex", marginBottom: "20px" }}>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("WALKINREPORTLBL6")}
                        </FormLabel>
                        <Android12Switch
                          checked={state.walkInRegistartionApproval}
                          onChange={handleChange}
                          name="walkInRegistartionApproval"
                          mode={darkMode}
                        />
                      </Grid>
                    </Grid>
                    <Grid style={{ display: "flex", marginBottom: "20px" }}>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("SELFREGISTRATIONLBL1")}
                        </FormLabel>
                        <Android12Switch
                          checked={state.selfRegistartionApproval}
                          onChange={handleChange}
                          name="selfRegistartionApproval"
                          mode={darkMode}
                        />
                      </Grid>
                    </Grid>
                    <Grid style={{ display: "flex", marginBottom: "20px" }}>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("AUTO_CHECK_OUT")}
                        </FormLabel>
                        <Android12Switch
                          checked={state.autoCheckOut}
                          onChange={handleChange}
                          name="autoCheckOut"
                          mode={darkMode}
                        />
                      </Grid>
                    </Grid>
                    {deliveryPermission ? (
                      <Grid style={{ display: "flex", marginBottom: "20px" }}>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                        >
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("DELIVERYOPTION")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.delivery}
                            onChange={handleChange}
                            name="delivery"
                            mode={darkMode}
                            // disabled={deliveryMobileShow}
                          />
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    <Grid style={{ display: "flex", marginBottom: "20px" }}>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("BADGEPRINT")}
                        </FormLabel>
                        <Android12Switch
                          checked={checkBadgePrint}
                          onChange={handleBadgePrint}
                          mode={darkMode}
                        />
                      </Grid>
                    </Grid>
                    <Grid style={{ display: "flex", marginBottom: "20px" }}>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("VISPUPUPDSUC003")}
                        </FormLabel>
                        <Android12Switch
                          checked={state.printerStatus}
                          onChange={handleChange}
                          name="printerStatus"
                          mode={darkMode}
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                  <RadioGroup
                    value={state.printerDevice}
                    name="printerDevice"
                    onChange={handlePrintDevice}
                    row
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    <FormControlLabel
                      disabled={!state.printerStatus}
                      value="Kiosk"
                      control={
                        <Radio
                          sx={{
                            color: darkMode ? "#fff" : "#707070",
                            "&.Mui-checked": {
                              color: darkMode ? "#fff" : "#707070",
                            },
                          }}
                        />
                      }
                      label="Kiosk"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          color: darkMode ? "#fff" : "#707070",
                        },
                      }}
                    />
                    <FormControlLabel
                      disabled={!state.printerStatus}
                      value="Brother"
                      control={
                        <Radio
                          sx={{
                            color: darkMode ? "#fff" : "#707070",
                            "&.Mui-checked": {
                              color: darkMode ? "#fff" : "#707070",
                            },
                          }}
                        />
                      }
                      label="Brother"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          color: darkMode ? "#fff" : "#707070", // Label color
                        },
                      }}
                    />
                  </RadioGroup>

                  {/*DateFormat*/}
                  <Grid style={{ display: "flex", marginBottom: "20px" }}>
                    <Grid className={darkMode ? "leftSwitch4" : "leftSwitch2"}>
                      <FormLabel
                        component="legend"
                        className={darkMode ? "formLabel2" : "formLabel"}
                      >
                        {t("APRMODE2")}
                        <Divider orientation="horizontal" />
                        <br />
                        <Grid style={{ display: "flex", marginBottom: "20px" }}>
                          <Grid item xs={12} sm={9}>
                            <Autocomplete
                              popupIcon={<ExpandMoreIcon />}
                              sx={{
                                width: 300,
                              }}
                              noOptionsText={"No Options found"}
                              onChange={handleDataFormat}
                              options={dateFormats}
                              defaultValue={dateFormats[0]}
                              value={
                                dateFormats.find(
                                  (option) => option.value === state.dateFormat,
                                ) || null
                              }
                              renderInput={(params) => (
                                <TextField {...params} label={t("APRMODE3")} />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </FormLabel>
                    </Grid>
                  </Grid>

                  {/*Proxy Domain*/}
                  <Grid style={{ display: "flex", marginBottom: "20px" }}>
                    <Grid className={darkMode ? "leftSwitch4" : "leftSwitch2"}>
                      <FormLabel
                        component="legend"
                        className={darkMode ? "formLabel2" : "formLabel"}
                      >
                        {t("PROXY_DOMAIN")}
                        <Divider orientation="horizontal" />
                        <Grid container sx={{ marginTop: "16px" }}>
                          <Grid item lg={4} sm={4}>
                            <CustomTextfield
                              label={t("PROXY_DOMAIN")}
                              error={error.proxyDomain}
                              name="proxyDomain"
                              value={state.proxyDomain.replace("@", "")}
                              handleChange={(e) => handleProxyDomain(e)}
                              helperText={error.proxyDomain}
                              required={true}
                              autoComplete="off"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      @{" "}
                                    </span>
                                  </InputAdornment>
                                ),
                                style: { color: darkMode ? "#fff" : "black" },
                              }}
                              inputProps={{ maxLength: 30 }}
                            />
                          </Grid>
                        </Grid>
                      </FormLabel>
                    </Grid>
                  </Grid>
                </FormControl>

                <Grid
                  style={{
                    marginBottom: "16px",
                    backgroundColor: darkMode ? "#1b3245" : "#f7f8fa",
                    padding: "12px 12px 25px 12px",
                  }}
                >
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <FormLabel
                      component="legend"
                      className={darkMode ? "formLabel2" : "formLabel"}
                    >
                      {t("AUTO_REPORT")}
                    </FormLabel>
                    <Android12Switch
                      checked={state.autoVisitorsReport}
                      onChange={handleAutoReport}
                      name="autoVisitorsReport"
                      mode={darkMode}
                    />
                  </Grid>
                  {state.autoVisitorsReport && (
                    <>
                      <Divider orientation="horizontal" />
                      <Grid
                        container
                        alignItems="center"
                        spacing={1}
                        style={{ marginBottom: "10px" }}
                      >
                        <Grid item xs={2} md={2}>
                          <FormLabel
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("AUTO_REPORT_MODE")}
                          </FormLabel>
                        </Grid>
                        <Grid item xs={10} md={10}>
                          <FormGroup row>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={invitationReports}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                />
                              }
                              checked={!state.invitationReports}
                              onChange={handleCheckBoxAutoReportInvitation}
                              name="invitationReports"
                              label="Invitation Report"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                              }}
                            />
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={walkInRegistrationReports}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                />
                              }
                              checked={!state.walkInRegistrationReports}
                              onChange={handleCheckBoxAutoReportWalkIn}
                              name="walkInRegistrationReports"
                              label="Walk-In Registration Report"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                              }}
                            />
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={selfRegistrationReports}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                />
                              }
                              checked={!state.selfRegistrationReports}
                              onChange={handleCheckBoxAutoReportSelf}
                              name="selfRegistrationReports"
                              label="Self Registration Report"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        alignItems="center"
                        spacing={1}
                        style={{ marginBottom: "10px" }}
                      >
                        <Grid item xs={2} md={2}>
                          <FormLabel
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("AUTO_RECEIVE")}
                          </FormLabel>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <TextField
                            fullWidth
                            label="Email"
                            placeholder="Enter email"
                            value={receiverEmailIds}
                            required
                            onChange={handleChangeEamilIds}
                            error={!!emailError}
                            helperText={emailError}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Tooltip title={t("RECEIVE_EMAIL_INFO")}>
                                    <InfoSharpIcon
                                      sx={{
                                        cursor: "pointer",
                                        "&:hover": {
                                          color: darkMode ? "#fff" : "#000",
                                        },
                                        "&.MuiSvgIcon-root": {
                                          fill: darkMode ? "#fff" : "#0000008a",
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              "& .MuiInputLabel-root": {
                                color: "#a09e9e !important",
                              },
                              "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root:hover": {
                                color: darkMode
                                  ? "#ffffff !important"
                                  : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                color: darkMode ? "#f8f9ff" : "black",
                                "& fieldset": {
                                  borderColor: darkMode ? "#777" : "#ccc",
                                },
                                "&:hover fieldset": {
                                  borderColor: darkMode
                                    ? "#ffffff"
                                    : "#a09e9e !important",
                                },
                              },
                            }}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        alignItems="center"
                        spacing={1}
                        style={{ paddingTop: "18px" }}
                      >
                        <Grid item xs={2} md={2}>
                          <FormLabel
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("AUTO_FREQUENCY")}
                          </FormLabel>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <Autocomplete
                            options={["Weekly", "Monthly"]}
                            value={state.visitorsReportsFrequency}
                            onChange={(e, newValue) => {
                              setState((prev) => ({
                                ...prev,
                                visitorsReportsFrequency: newValue,
                                recurrenceDay: null,
                              }));
                              setError({ visitorsReportsFrequency: false });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Frequency"
                                variant="outlined"
                                error={error.visitorsReportsFrequency}
                                required
                              />
                            )}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          style={{ paddingLeft: "18px" }}
                        >
                          <Autocomplete
                            options={
                              state.visitorsReportsFrequency === "Weekly"
                                ? weeklyDays
                                : monthlyDate
                            }
                            value={valueOfRecurrenDays}
                            onChange={(e, newValue) => {
                              setValueOfRecurrenDays(newValue);
                              setState((prev) => ({
                                ...prev,
                                recurrenceDay: newValue?.value || null,
                              }));
                              setError({ recurrenceDay: false });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Day"
                                variant="outlined"
                                required
                                error={error.recurrenceDay}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>

                <Grid style={{ display: "flex", marginBottom: "20px" }}>
                  <Grid className={darkMode ? "leftSwitch4" : "leftSwitch2"}>
                    <FormLabel
                      component="legend"
                      className={darkMode ? "formLabel2" : "formLabel"}
                    >
                      {t("Card Number Range")}
                      <Divider orientation="horizontal" />

                      <Grid container spacing={2}>
                        <Grid item xs={6} md={4}>
                          <CustomTextfields
                            name="globalCardNumberMinRange"
                            handleChange={handleCardMin}
                            required={true}
                            value={state.globalCardNumberMinRange}
                            label="Card Number Min Range"
                            error={error.globalCardNumberMinRange}
                            validation="numeric"
                            maxLength={5}
                            sx={cardRangeFieldSx}
                          />
                        </Grid>

                        <Grid item xs={6} md={4}>
                          <CustomTextfields
                            name="globalCardNumberMaxRange"
                            handleChange={handleCardMax}
                            required={true}
                            value={state.globalCardNumberMaxRange}
                            label="Card Number Max Range"
                            error={error.globalCardNumberMaxRange}
                            validation="numeric"
                            maxLength={5}
                            sx={cardRangeFieldSx}
                          />
                        </Grid>
                      </Grid>
                    </FormLabel>
                  </Grid>
                </Grid>

                <FormControl
                  component="fieldset"
                  variant="standard"
                  style={{
                    backgroundColor: darkMode ? "#0E2A41" : "#fff",
                  }}
                >
                  <FormLabel
                    component="legend"
                    className={darkMode ? "AddtionalTitle1" : "AddtionalTitle"}
                  >
                    {t("VISPUPUPDSUC004")}
                  </FormLabel>
                  <br />
                  <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleChangeAccordian("panel1")}
                    style={{
                      marginTop: "-18px",
                      backgroundColor: darkMode ? "#0E2A41" : "#fff",
                    }}
                  >
                    <AccordionSummary
                      style={{
                        backgroundColor: "#F7F8FA",
                        borderBottom: darkMode ? "" : "1px solid #E6E6E6",
                        backgroundColor: darkMode ? "#1B3245" : "#fff",
                      }}
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: "#949596",
                          }}
                        />
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <FormLabel
                        component="legend"
                        className={darkMode ? "formLabel2" : "formLabel"}
                      >
                        {t("labelDashBoardTotalReschedule")}
                      </FormLabel>
                    </AccordionSummary>

                    <AccordionDetails>
                      <FormGroup>
                        {/* Add for mandatory feild Invitation*/}
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                        >
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel4" : "formLabel1"}
                          >
                            Profile Photo
                          </FormLabel>
                          <Android12Switch
                            checked={state.invitationProfilePhoto}
                            onChange={handleChangeInvitationProfilePhoto}
                            name="invitationProfilePhoto"
                            mode={darkMode}
                          />
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              disabled={!state.invitationProfilePhoto}
                              control={
                                <Checkbox
                                  checked={invitationProfilePhotoMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                />
                              }
                              checked={!state.invitationProfilePhoto}
                              onChange={handleCheckBoxInvitationProfilePhoto}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid style={{ display: "flex", marginBottom: "0px" }}>
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Purpose of Visit
                            </FormLabel>
                            <Android12Switch
                              checked={state.invitationPurposeType}
                              onChange={handleChangeInvitationPurposeType}
                              name="invitationPurposeType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              disabled={!state.invitationPurposeType}
                              control={
                                <Checkbox
                                  checked={invitationPurposeTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                />
                              }
                              checked={!state.invitationPurposeType}
                              onChange={handleCheckBoxInvitationPurposeType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Visitor Type
                            </FormLabel>
                            <Android12Switch
                              checked={state.invitationVisitorType}
                              onChange={handleChangeInvitationVisitorType}
                              name="invitationVisitorType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={invitationVisitorTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.invitationVisitorType}
                                />
                              }
                              checked={!state.invitationVisitorType}
                              onChange={handleCheckBoxInvitationVisitorType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Company Name
                            </FormLabel>
                            <Android12Switch
                              checked={state.invitationCompanyName}
                              onChange={handleChangeInvitationCompanyName}
                              name="invitationCompanyName"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={invitationCompanyNameMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.invitationCompanyName}
                                />
                              }
                              checked={!state.invitationCompanyName}
                              onChange={handleCheckBoxInvitationCompanyName}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        {/* <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Site
                            </FormLabel>
                            <Android12Switch
                              checked={state.invitationSiteType}
                              onChange={handleChangeInvitationSiteType}
                              name="invitationSiteType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={invitationSiteTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.invitationSiteType}
                                />
                              }
                              checked={!state.invitationSiteType}
                              onChange={handleCheckBoxInvitationSiteType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" /> */}
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Confirmation
                            </FormLabel>
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={invitationByPass}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": {
                                      color: "#F2824C",
                                    },
                                  }}
                                />
                              }
                              label={"Confirmation detail for visitor"}
                              onClick={handleInvitationBypass}
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        {invitationByPass && (
                          <>
                            <Divider orientation="horizontal" />
                            <Grid
                              style={{
                                display: "flex",
                                marginBottom: "0px",
                                paddingBottom: "0px",
                              }}
                            >
                              <Grid
                                className={
                                  darkMode ? "leftSwitch3" : "leftSwitch1"
                                }
                              >
                                <FormLabel
                                  component="legend"
                                  className={
                                    darkMode ? "formLabel4" : "formLabel1"
                                  }
                                >
                                  {t("NDA")}
                                </FormLabel>
                                <Android12Switch
                                  checked={state.invitationNDA}
                                  onChange={handleNDAChange}
                                  name="invitationNDA"
                                  mode={darkMode}
                                />
                              </Grid>
                            </Grid>
                            {state.invitationNDA && (
                              <Grid
                                className={
                                  darkMode ? "leftSwitch3" : "leftSwitch1"
                                }
                                style={{
                                  display: "flex",
                                  marginTop: "0px",
                                  paddingTop: "0px",
                                }}
                              >
                                <FormGroup>
                                  <CustomFormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          invitationNDANotifictionMandatory
                                        }
                                        sx={{
                                          color: "#F2824C",
                                          "&.Mui-checked": {
                                            color: "#F2824C",
                                          },
                                        }}
                                        disabled={!state.invitationNDA}
                                      />
                                    }
                                    checked={!state.invitationNDA}
                                    onChange={
                                      handleCheckBoxInvitationNDANotification
                                    }
                                    name="invitationNDANotification"
                                    label="NDA Notification"
                                    sx={{
                                      color: darkMode ? "#fff" : "#000",
                                      "& .MuiFormControlLabel-label": {
                                        color: darkMode ? "#fff" : "#000",
                                      },
                                      "&.Mui-disabled": {
                                        color: darkMode
                                          ? "#fff !important"
                                          : "#aaa !important", // Set color when disabled
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Grid>
                            )}
                          </>
                        )}

                        {invitationByPass && (
                          <>
                            <Divider orientation="horizontal" />

                            <Grid
                              className={
                                darkMode ? "leftSwitch3" : "leftSwitch1"
                              }
                            >
                              <FormLabel
                                component="legend"
                                className={
                                  darkMode ? "formLabel4" : "formLabel1"
                                }
                              >
                                {t("VIDEO_VIEW")}
                              </FormLabel>
                              <Android12Switch
                                checked={state.invitationSafetyVideo}
                                onChange={handleChange}
                                name="invitationSafetyVideo"
                                mode={darkMode}
                              />
                            </Grid>
                          </>
                        )}
                        <Grid container spacing={2}>
                          <Grid item sm={3}>
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                              style={{
                                marginTop: "10px",
                              }}
                            >
                              {t("labelDashBoardTotalReschedule1")}
                            </FormLabel>
                            <CustomTextfield
                              label="Select Interval Time"
                              error={error.invitationIntervalTime}
                              name="invitationIntervalTime"
                              value={state.invitationIntervalTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                              style={{
                                marginTop: "5px",
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 1.5 }}>
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel4" : "formLabel1"}
                            style={{
                              marginLeft: "18px",
                            }}
                          >
                            {t("SETTING1")}
                          </FormLabel>
                          <Grid item sm={3} style={{ paddingTop: "5px" }}>
                            <CustomTextfield
                              maxLength={5}
                              label="Early Allow to Check-In"
                              error={error.invitationEarlyCheckInTime}
                              name="invitationEarlyCheckInTime"
                              value={state.invitationEarlyCheckInTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                          <Grid item sm={3} style={{ paddingTop: "5px" }}>
                            <CustomTextfield
                              maxLength={5}
                              label="Alert to Late Check-Out"
                              error={error.invitationLateCheckOutTime}
                              name="invitationLateCheckOutTime"
                              value={state.invitationLateCheckOutTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                        </Grid>
                        <>
                          <Grid
                            style={{
                              display: "flex",
                              marginBottom: "5px",
                              marginTop: "10px",
                            }}
                          >
                            <Grid
                              className={
                                darkMode ? "leftSwitch3" : "leftSwitch1"
                              }
                            >
                              <FormLabel
                                component="legend"
                                className={
                                  darkMode ? "formLabel2" : "formLabel"
                                }
                              >
                                {t("QRCODE1")}
                              </FormLabel>
                              <Android12Switch
                                checked={qrCode}
                                onChange={handleChangeQR}
                                name="invitationVerifyMode"
                                mode={darkMode}
                              />
                            </Grid>
                          </Grid>
                          {qrCode && (
                            <Grid container spacing={2}>
                              {/* Scan Limit */}
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                style={{ marginTop: "17px" }}
                              >
                                <CustomTextfield
                                  disabled={!qrCode}
                                  maxLength={3}
                                  label={t("COMMON151")}
                                  error={error.invitationScanLimit}
                                  name="invitationScanLimit"
                                  value={state.invitationScanLimit}
                                  handleChange={(e) =>
                                    handleChangeofDropdown(e)
                                  }
                                  validation="numeric"
                                  required={true}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <span
                                          style={{
                                            color: darkMode ? "#fff" : "",
                                          }}
                                        >
                                          {t("SETTINGS002")}
                                        </span>
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputProps={{ maxLength: 3 }}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </>
                        <>
                          <Grid style={{ display: "flex", marginTop: "10px" }}>
                            <Grid
                              className={
                                darkMode ? "leftSwitch3" : "leftSwitch1"
                              }
                            >
                              <FormLabel
                                component="legend"
                                className={
                                  darkMode ? "formLabel2" : "formLabel"
                                }
                              >
                                {t("SETTINGS003")}
                              </FormLabel>
                              <Android12Switch
                                checked={digitCode}
                                onChange={handleChangeDigit}
                                name="invitationVerifyMode"
                                mode={darkMode}
                              />
                            </Grid>
                          </Grid>
                          {digitCode && (
                            <Grid item sm={6} sx={{ width: "320px", mt: 2 }}>
                              <CustomDropdown
                                disabled={digitCode ? false : true}
                                label="Select Digit Code Type"
                                value={state.invitationCodeDigits}
                                error={error.invitationCodeDigits}
                                name="invitationCodeDigits"
                                data={Digit}
                                handleChange={(e) => handleChangeofDropdown(e)}
                              />
                            </Grid>
                          )}
                        </>
                      </FormGroup>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChangeAccordian("panel2")}
                    style={{
                      marginTop: "30px",
                      backgroundColor: darkMode ? "#0E2A41" : "#fff",
                    }}
                  >
                    <AccordionSummary
                      style={{
                        backgroundColor: "#F7F8FA",
                        borderBottom: darkMode ? "" : "1px solid #E6E6E6",
                        backgroundColor: darkMode ? "#1B3245" : "#fff",
                      }}
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: "#949596",
                          }}
                        />
                      }
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <FormLabel
                        component="legend"
                        className={darkMode ? "formLabel2" : "formLabel"}
                      >
                        {t("WALKINREPORTLBL")}
                      </FormLabel>
                    </AccordionSummary>
                    <AccordionDetails>
                      {/*Base on addition setting walkin part field will work*/}
                      <FormGroup>
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel2" : "formLabel"}
                            >
                              {t("AUTO_CONTACT_INFO")}
                            </FormLabel>
                            <Android12Switch
                              checked={state.walkInAutoContactInfo}
                              onChange={handleWalkInAutoContactInfo}
                              name="walkInAutoContactInfo"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Profile Photo
                            </FormLabel>
                            <Android12Switch
                              checked={state.walkInRegistrationProfilePhoto}
                              onChange={handleChangeWalkInProfilePhoto}
                              name="walkInRegistrationProfilePhoto"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={WalkInProfilePhotoMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={
                                    !state.walkInRegistrationProfilePhoto
                                  }
                                />
                              }
                              checked={!state.walkInRegistrationProfilePhoto}
                              onChange={handleCheckBoxWalkInProfilePhoto}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid style={{ display: "flex", marginBottom: "0px" }}>
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Purpose of Visit
                            </FormLabel>
                            <Android12Switch
                              checked={state.walkInRegistrationPurposeType}
                              onChange={handleChangeWalkInPurposeType}
                              name="walkInRegistrationPurposeType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={walkInPurposeTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={
                                    !state.walkInRegistrationPurposeType
                                  }
                                />
                              }
                              checked={!state.walkInRegistrationPurposeType}
                              onChange={handleCheckBoxWalkInPurposeType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Visitor Type
                            </FormLabel>
                            <Android12Switch
                              checked={state.walkInRegistrationVisitorType}
                              onChange={handleChangeWalkInVisitorType}
                              name="walkInRegistrationVisitorType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={walkInVisitorTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={
                                    !state.walkInRegistrationVisitorType
                                  }
                                />
                              }
                              checked={!state.walkInRegistrationVisitorType}
                              onChange={handleCheckBoxWalkInVisitorType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important",
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Company Name
                            </FormLabel>
                            <Android12Switch
                              checked={state.wlakInRegistrationCompanyName}
                              onChange={handleChangeWalkInCompanyName}
                              name="wlakInRegistrationCompanyName"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={walkInCompanyNameMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={
                                    !state.wlakInRegistrationCompanyName
                                  }
                                />
                              }
                              checked={!state.wlakInRegistrationCompanyName}
                              onChange={handleCheckBoxWalkInCompanyName}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        {/* <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Site
                            </FormLabel>
                            <Android12Switch
                              checked={state.walkInRegistrationSiteType}
                              onChange={handleChangeWalkInSiteType}
                              name="walkInRegistrationSiteType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={walkInSiteTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.walkInRegistrationSiteType}
                                />
                              }
                              checked={!state.walkInRegistrationSiteType}
                              onChange={handleCheckBoxWalkInSiteType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid> */}
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Signature On Kiosk
                            </FormLabel>
                            <Android12Switch
                              checked={state.walkInRegistrationSignatureOnKiosk}
                              onChange={handleChangeWalkInSignature}
                              name="walkInRegistrationSignatureOnKiosk"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={WalkInSignatureMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={
                                    !state.walkInRegistrationSignatureOnKiosk
                                  }
                                />
                              }
                              checked={
                                !state.walkInRegistrationSignatureOnKiosk
                              }
                              onChange={handleCheckBoxSignature}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Confirmation
                            </FormLabel>
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={walkInBypass}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": {
                                      color: "#F2824C",
                                    },
                                  }}
                                />
                              }
                              label={t("CONFIRMATION_BYPASS")}
                              sx={{
                                color: darkMode ? "#fff" : "inherit",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                              }}
                              onClick={handleWalkInBypass}
                            />
                            {enableDLMobile && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={checked}
                                    sx={{
                                      color: "#F2824C",
                                      "&.Mui-checked": {
                                        color: "#F2824C",
                                      },
                                    }}
                                  />
                                }
                                label={
                                  checked
                                    ? "DL Walk-In on mobile  "
                                    : "Enable DL Walk-In on mobile"
                                }
                                sx={{
                                  color: darkMode ? "#fff" : "",
                                  "& .MuiFormControlLabel-label": {
                                    color: darkMode ? "#fff" : "#000",
                                  },
                                }}
                                onClick={handleCheckBox}
                              />
                            )}
                            {offenderFeature && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="offenderVerification"
                                    checked={state.offenderVerification}
                                    sx={{
                                      color: "#F2824C",
                                      "&.Mui-checked": {
                                        color: "#F2824C",
                                      },
                                    }}
                                  />
                                }
                                label={t("OFFENDER_CHECK")}
                                sx={{
                                  color: darkMode ? "#fff" : "inherit",
                                  "& .MuiFormControlLabel-label": {
                                    color: darkMode ? "#fff" : "#000",
                                  },
                                }}
                                onClick={handleChange}
                              />
                            )}
                          </FormGroup>
                        </Grid>
                        {walkInBypass && (
                          <>
                            <Divider orientation="horizontal" />
                            <Grid
                              style={{
                                display: "flex",
                                marginBottom: "0px",
                                paddingBottom: "0px",
                              }}
                            >
                              <Grid
                                className={
                                  darkMode ? "leftSwitch3" : "leftSwitch1"
                                }
                              >
                                <FormLabel
                                  component="legend"
                                  className={
                                    darkMode ? "formLabel4" : "formLabel1"
                                  }
                                >
                                  {t("NDA")}
                                </FormLabel>
                                <Android12Switch
                                  checked={state.walkInRegistrationNDA}
                                  onChange={handleNDAChange}
                                  name="walkInRegistrationNDA"
                                  mode={darkMode}
                                />
                              </Grid>
                            </Grid>
                            {state.walkInRegistrationNDA && (
                              <Grid
                                className={
                                  darkMode ? "formLabel4" : "formLabel1"
                                }
                                style={{
                                  display: "flex",
                                  marginTop: "0px",
                                  paddingTop: "0px",
                                }}
                              >
                                <FormGroup>
                                  <CustomFormControlLabel
                                    control={
                                      <Checkbox
                                        checked={walkInNDANotifictionMandatory}
                                        sx={{
                                          color: "#F2824C",
                                          "&.Mui-checked": { color: "#F2824C" },
                                        }}
                                        disabled={!state.walkInRegistrationNDA}
                                      />
                                    }
                                    checked={state.walkInRegistrationNDA}
                                    onChange={
                                      handleCheckBoxWalkInNDANotification
                                    }
                                    name="walkInRegistrationNDANotification"
                                    label="NDA Notification"
                                    sx={{
                                      color: darkMode ? "#fff" : "#000",
                                      "& .MuiFormControlLabel-label": {
                                        color: darkMode ? "#fff" : "#000",
                                      },
                                      "&.Mui-disabled": {
                                        color: darkMode
                                          ? "#fff !important"
                                          : "#aaa !important", // Set color when disabled
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Grid>
                            )}
                          </>
                        )}
                        {/**DL Persmission */}
                        {documentCapture && (
                          <>
                            <Divider orientation="horizontal" />
                            <Grid
                              style={{
                                display: "flex",
                                marginBottom: "0px",
                                paddingBottom: "0px",
                              }}
                            >
                              <Grid
                                className={
                                  darkMode ? "leftSwitch3" : "leftSwitch1"
                                }
                              >
                                <FormLabel
                                  component="legend"
                                  className={
                                    darkMode ? "formLabel4" : "formLabel1"
                                  }
                                >
                                  {t("ENABLE_DL")}
                                </FormLabel>
                                <Android12Switch
                                  checked={state.documentCapture}
                                  onChange={handleChange}
                                  name="documentCapture"
                                  mode={darkMode}
                                />
                              </Grid>
                            </Grid>
                          </>
                        )}

                        <Divider orientation="horizontal" />

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                        >
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel4" : "formLabel1"}
                          >
                            {t("VIDEO_VIEW")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.walkInSafetyVideo}
                            onChange={handleChange}
                            name="walkInSafetyVideo"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid sx={{ mt: "10px" }}>
                          <Autocomplete
                            popupIcon={<ExpandMoreIcon />}
                            options={employees}
                            getOptionLabel={(option) =>
                              option.lastName
                                ? option.firstName + " " + option.lastName
                                : option.firstName
                                ? option.firstName
                                : ""
                            }
                            value={selectedWalkIHost}
                            onChange={handleSelectionForWalkInHost}
                            renderInput={(params) => (
                              <CustomTextfield
                                {...params}
                                label="Default Host"
                              />
                            )}
                            sx={{
                              width: 300,
                            }}
                          />
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: -1 }}>
                          <Grid item sm={3}>
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                              style={{
                                marginBottom: "11px",
                              }}
                            >
                              {t("labelDashBoardTotalReschedule1")}
                            </FormLabel>
                            <CustomTextfield
                              label="Select Interval Time"
                              error={error.walkInIntervalTime}
                              name="walkInIntervalTime"
                              value={state.walkInIntervalTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {" "}
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 1.5 }}>
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel4" : "formLabel1"}
                            style={{
                              marginLeft: "18px",
                            }}
                          >
                            {t("SETTING1")}
                          </FormLabel>
                          <Grid item sm={3} style={{ paddingTop: "5px" }}>
                            <CustomTextfield
                              label="Early Allow to Check-In"
                              error={error.walkInEarlyCheckInTime}
                              name="walkInEarlyCheckInTime"
                              value={state.walkInEarlyCheckInTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                          <Grid item sm={3} style={{ paddingTop: "5px" }}>
                            <CustomTextfield
                              label="Alert to Late Check-Out"
                              error={error.walkInLateCheckOutTime}
                              name="walkInLateCheckOutTime"
                              value={state.walkInLateCheckOutTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "5px",
                            marginTop: "15px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel2" : "formLabel"}
                            >
                              {t("QRCODE1")}
                            </FormLabel>
                            <Android12Switch
                              checked={qrCode1}
                              onChange={handleChangeQR1}
                              name="walkInRegistartionVerifyMode"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        {qrCode1 && (
                          <Grid container spacing={2}>
                            {/* Scan Limit */}
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              style={{ marginTop: "17px" }}
                            >
                              <CustomTextfield
                                disabled={!qrCode1}
                                maxLength={3}
                                label={t("COMMON151")}
                                error={error.walkInScanLimit}
                                name="walkInScanLimit"
                                value={state.walkInScanLimit}
                                handleChange={(e) => handleChangeofDropdown(e)}
                                validation="numeric"
                                required={true}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <span
                                        style={{
                                          color: darkMode ? "#fff" : "",
                                        }}
                                      >
                                        {t("SETTINGS002")}
                                      </span>
                                    </InputAdornment>
                                  ),
                                }}
                                inputProps={{ maxLength: 3 }}
                              />
                            </Grid>
                          </Grid>
                        )}
                        <Grid style={{ display: "flex", marginTop: "10px" }}>
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel2" : "formLabel"}
                            >
                              {t("SETTINGS003")}
                            </FormLabel>
                            <Android12Switch
                              checked={digitCode1}
                              onChange={handleChangeDigit1}
                              name="walkInRegistartionVerifyMode"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        {digitCode1 && (
                          <Grid item sm={6} sx={{ width: "320px", mt: 2 }}>
                            <CustomDropdown
                              disabled={digitCode1 ? false : true}
                              label="Select Digit Code Type"
                              value={state.walkInCodeDigits}
                              error={error.walkInCodeDigits}
                              name="walkInCodeDigits"
                              data={Digit}
                              handleChange={(e) => handleChangeofDropdown(e)}
                            />
                          </Grid>
                        )}

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{ marginTop: "10px" }}
                        >
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("CAPTURE_IMAGE")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.walkInImageCapture}
                            onChange={handleImageCapture}
                            name="walkInImageCapture"
                            mode={darkMode}
                          />
                        </Grid>
                        {state.walkInImageCapture && (
                          <Grid
                            item
                            sm={6}
                            sx={{ mb: 2, width: "320px", mt: "25px" }}
                          >
                            <CustomDropdown
                              label={t("NUMBER_OF_CAPTURE")}
                              value={state.walkInImagesCaptureLimit}
                              name="walkInImagesCaptureLimit"
                              data={captureLimit}
                              handleChange={(e) => handleChangeofDropdown(e)}
                            />
                          </Grid>
                        )}
                      </FormGroup>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    expanded={expanded === "panel3"}
                    onChange={handleChangeAccordian("panel3")}
                    style={{
                      marginTop: "30px",
                      backgroundColor: darkMode ? "#0E2A41" : "#fff",
                    }}
                  >
                    <AccordionSummary
                      style={{
                        backgroundColor: "#F7F8FA",
                        borderBottom: darkMode ? "" : "1px solid #E6E6E6",
                        backgroundColor: darkMode ? "#1B3245" : "#fff",
                      }}
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: "#949596",
                          }}
                        />
                      }
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <FormLabel
                        component="legend"
                        className={darkMode ? "formLabel2" : "formLabel"}
                      >
                        {t("SELFREGISTRATIONLBL")}
                      </FormLabel>
                    </AccordionSummary>

                    <AccordionDetails>
                      <FormGroup>
                        {/*selfregistration mandatory field */}
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel2" : "formLabel"}
                            >
                              {t("AUTO_CONTACT_INFO")}
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfAutoContactInfo}
                              onChange={handleSelfAutoContactInfo}
                              name="selfAutoContactInfo"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Profile Photo
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfRegistrationProfilePhoto}
                              onChange={handleChangeSelfProfilePhoto}
                              name="selfRegistrationProfilePhoto"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selfRegistrationProfilePhotoMandatory
                                  }
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.selfRegistrationProfilePhoto}
                                />
                              }
                              checked={!state.selfRegistrationProfilePhoto}
                              onChange={handleCheckBoxSelfProfilePhoto}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid style={{ display: "flex", marginBottom: "0px" }}>
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Purpose of Visit
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfRegistrationPurposeType}
                              onChange={handleChangeSelfPurposeType}
                              name="selfRegistrationPurposeType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={selfRegistrationPurposeTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.selfRegistrationPurposeType}
                                />
                              }
                              checked={!state.selfRegistrationPurposeType}
                              onChange={handleCheckBoxSelfPurposeType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Visitor Type
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfRegistrationVisitorType}
                              onChange={handleChangeSelfVisitorType}
                              name="selfRegistrationVisitorType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={selfRegistrationVisitorTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.selfRegistrationVisitorType}
                                />
                              }
                              checked={!state.selfRegistrationVisitorType}
                              onChange={handleCheckBoxSelfVisitorType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Company Name
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfRegistrationCompanyName}
                              onChange={handleChangeSelfCompanyName}
                              name="selfRegistrationCompanyName"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={selfRegistrationCompanyNameMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.selfRegistrationCompanyName}
                                />
                              }
                              checked={!state.selfRegistrationCompanyName}
                              onChange={handleCheckBoxSelfCompanyName}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid>
                        <Divider orientation="horizontal" />
                        {/* <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              Site
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfRgistrationSiteType}
                              onChange={handleChangeSelfSiteType}
                              name="selfRgistrationSiteType"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid> */}

                        {/* <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          style={{
                            display: "flex",
                            marginTop: "0px",
                            paddingTop: "0px",
                          }}
                        >
                          <FormGroup>
                            <CustomFormControlLabel
                              control={
                                <Checkbox
                                  checked={selfRegistrationSiteTypeMandatory}
                                  sx={{
                                    color: "#F2824C",
                                    "&.Mui-checked": { color: "#F2824C" },
                                  }}
                                  disabled={!state.selfRgistrationSiteType}
                                />
                              }
                              checked={!state.selfRgistrationSiteType}
                              onChange={handleCheckBoxSelfSiteType}
                              label="Mandatory Field"
                              sx={{
                                color: darkMode ? "#fff" : "#000",
                                "& .MuiFormControlLabel-label": {
                                  color: darkMode ? "#fff" : "#000",
                                },
                                "&.Mui-disabled": {
                                  color: darkMode
                                    ? "#fff !important"
                                    : "#aaa !important", // Set color when disabled
                                },
                              }}
                            />
                          </FormGroup>
                        </Grid> */}
                        {/* <Divider orientation="horizontal" /> */}
                        <Grid
                          style={{
                            display: "flex",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                            >
                              {t("NDA")}
                            </FormLabel>
                            <Android12Switch
                              checked={state.selfRegistrationNDA}
                              onChange={handleNDAChange}
                              name="selfRegistrationNDA"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        {state.selfRegistrationNDA && (
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                            style={{
                              display: "flex",
                              marginTop: "0px",
                              paddingTop: "0px",
                            }}
                          >
                            <FormGroup>
                              <CustomFormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      selfRegistrationNDANotifictionMandatory
                                    }
                                    sx={{
                                      color: "#F2824C",
                                      "&.Mui-checked": { color: "#F2824C" },
                                    }}
                                    disabled={!state.selfRegistrationNDA}
                                  />
                                }
                                checked={state.selfRegistrationNDA}
                                onChange={
                                  handleCheckBoxSelfRegistrationNDANotification
                                }
                                name="selfRegistrationNDANotification"
                                label="NDA Notification"
                                sx={{
                                  color: darkMode ? "#fff" : "#000",
                                  "& .MuiFormControlLabel-label": {
                                    color: darkMode ? "#fff" : "#000",
                                  },
                                  "&.Mui-disabled": {
                                    color: darkMode
                                      ? "#fff !important"
                                      : "#aaa !important", // Set color when disabled
                                  },
                                }}
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        <Divider orientation="horizontal" />

                        <Grid
                          className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                        >
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel4" : "formLabel1"}
                          >
                            {t("VIDEO_VIEW")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.selfRegistrationSafetyVideo}
                            onChange={handleChange}
                            name="selfRegistrationSafetyVideo"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid sx={{ mt: "10px" }}>
                          <Autocomplete
                            popupIcon={<ExpandMoreIcon />}
                            options={employees}
                            getOptionLabel={(option) =>
                              option.lastName
                                ? option.firstName + " " + option.lastName
                                : option.firstName
                                ? option.firstName
                                : ""
                            }
                            value={selectedHost}
                            onChange={handleSelection}
                            renderInput={(params) => (
                              <CustomTextfield
                                {...params}
                                label="Default Host"
                              />
                            )}
                            sx={{
                              width: 300,
                            }}
                          />
                        </Grid>

                        <Grid container spacing={2} sx={{ mt: -1 }}>
                          <Grid item sm={3}>
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel4" : "formLabel1"}
                              style={{ marginBottom: "11px" }}
                            >
                              {t("labelDashBoardTotalReschedule1")}
                            </FormLabel>
                            <CustomTextfield
                              label="Select Interval Time"
                              error={error.selfIntervalTime}
                              name="selfIntervalTime"
                              value={state.selfIntervalTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 1.5 }}>
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel4" : "formLabel1"}
                            style={{
                              marginLeft: "18px",
                            }}
                          >
                            {t("SETTING1")}
                          </FormLabel>
                          <Grid item sm={3} style={{ paddingTop: "5px" }}>
                            <CustomTextfield
                              label="Early Allow to Check-In"
                              error={error.selfEarlyCheckInTime}
                              name="selfEarlyCheckInTime"
                              value={state.selfEarlyCheckInTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                          <Grid item sm={3} style={{ paddingTop: "5px" }}>
                            <CustomTextfield
                              label="Alert to Late Check-Out"
                              error={error.selfLateCheckOutTime}
                              name="selfLateCheckOutTime"
                              value={state.selfLateCheckOutTime}
                              handleChange={(e) => changeIntervalTime(e)}
                              required={true}
                              validation="numeric"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span
                                      style={{ color: darkMode ? "#fff" : "" }}
                                    >
                                      {t("MINT")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ maxLength: 5 }}
                            />
                          </Grid>
                        </Grid>
                        <>
                          <Grid
                            style={{
                              display: "flex",
                              marginBottom: "5px",
                              marginTop: "15px",
                            }}
                          >
                            <Grid
                              className={
                                darkMode ? "leftSwitch3" : "leftSwitch1"
                              }
                            >
                              <FormLabel
                                component="legend"
                                className={
                                  darkMode ? "formLabel2" : "formLabel"
                                }
                              >
                                {t("QRCODE1")}
                              </FormLabel>
                              <Android12Switch
                                checked={qrCode2}
                                onChange={handleChangeQR2}
                                name="selfRegistartionVerifyMode"
                                mode={darkMode}
                              />
                            </Grid>
                          </Grid>
                          {qrCode2 && (
                            <Grid container spacing={2}>
                              {/* Scan Limit */}
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                style={{ marginTop: "17px" }}
                              >
                                <CustomTextfield
                                  disabled={!qrCode2}
                                  label={t("COMMON151")}
                                  error={error.selfRegistartionScanLimit}
                                  name="selfRegistartionScanLimit"
                                  value={state.selfRegistartionScanLimit}
                                  handleChange={(e) =>
                                    handleChangeofDropdown(e)
                                  }
                                  validation="numeric"
                                  required={true}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <span
                                          style={{
                                            color: darkMode ? "#fff" : "",
                                          }}
                                        >
                                          {t("SETTINGS002")}
                                        </span>
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputProps={{ maxLength: 3 }}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </>
                        <Grid style={{ display: "flex", marginTop: "10px" }}>
                          <Grid
                            className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                          >
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel2" : "formLabel"}
                            >
                              {t("SETTINGS003")}
                            </FormLabel>
                            <Android12Switch
                              checked={digitCode2}
                              onChange={handleChangeDigit2}
                              name="selfRegistartionVerifyMode"
                              mode={darkMode}
                            />
                          </Grid>
                        </Grid>
                        {digitCode2 && (
                          <Grid item sm={6} sx={{ width: "320px", mt: 2 }}>
                            <CustomDropdown
                              disabled={digitCode2 ? false : true}
                              label="Select Digit Code Type"
                              value={state.selfRegistartionCodeDigits}
                              error={error.selfRegistartionCodeDigits}
                              name="selfRegistartionCodeDigits"
                              data={Digit}
                              handleChange={(e) => handleChangeofDropdown(e)}
                            />
                          </Grid>
                        )}
                      </FormGroup>
                      <Grid
                        className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                        style={{ marginTop: "10px" }}
                      >
                        <FormLabel
                          component="legend"
                          className={darkMode ? "formLabel2" : "formLabel"}
                        >
                          {t("CAPTURE_IMAGE")}
                        </FormLabel>
                        <Android12Switch
                          checked={state.selfImageCapture}
                          onChange={handleImageCapture}
                          name="selfImageCapture"
                          mode={darkMode}
                        />
                      </Grid>
                      {state.selfImageCapture && (
                        <Grid
                          item
                          sm={6}
                          sx={{ mb: 2, width: "320px", mt: "22px" }}
                        >
                          <CustomDropdown
                            label={t("NUMBER_OF_CAPTURE")}
                            value={state.selfImagesCaptureLimit}
                            name="selfImagesCaptureLimit"
                            data={captureLimit}
                            handleChange={(e) => handleChangeofDropdown(e)}
                          />
                        </Grid>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </FormControl>
              </Grid>
            </PerfectScrollbar>
          </Box>

          <Box
            sx={{
              p: 2,
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
              marginRight: "12px",
            }}
          >
            <Grid container justifyContent="flex-end" spacing={2}>
              <Grid item>
                <CancelButtons onClick={handleCancel}>
                  <Typography variant="body1" style={{ textTransform: "none" }}>
                    {t("COMMON008")}
                  </Typography>
                </CancelButtons>
              </Grid>
              <Grid item>
                <SubmitButtons onClick={handleSubmit} variant="contained">
                  <Typography>{t("COMMON007")}</Typography>
                </SubmitButtons>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </>
  );
}

export default AdditionalSettings;
